'use strict';

import BaseService from './base.service';

class OperationTypesService extends BaseService {
  /* @ngInject */
  constructor(OperationType, SegaUser) {
    super(OperationType, SegaUser);
  }

  removeStatesTemplate(operationType, statesTemplate) {
    return this.Model.removeStatesTemplate({
      operationTypeId: operationType.id,
      statesTemplateId: statesTemplate.id
    }).$promise;
  }

  addStatesTemplate(operationType, statesTemplate) {
    return this.Model.addStatesTemplate({
      operationTypeId: operationType.id,
      statesTemplateId: statesTemplate.id
    }).$promise;
  }
}

export default OperationTypesService;
